import React from 'react';
import { token } from '@atlaskit/tokens';
import { xcss, Box } from '@atlaskit/primitives';
import { Card } from '@atlaskit/media-card';
import type { FileIdentifier } from '@atlaskit/media-client';
import type { MediaClientConfig } from '@atlaskit/media-core';
import { fg } from '@atlassian/jira-feature-gating';
import { mediaFeatureFlags } from '../../../../../media-feature-flags.tsx';
import type { AttachmentActionItem } from '../types.tsx';
import { GRID_ITEM_DIMENSIONS } from '../constants.tsx';
import MediaCardItem from './media-card/index.tsx';

const cardDimensions = {
	width: '100%',
	height: GRID_ITEM_DIMENSIONS.height,
};

const MediaCardItems = ({
	items,
	mediaClientConfig,
	shouldEnableDownloadButton,
}: {
	items: AttachmentActionItem[];
	mediaClientConfig: MediaClientConfig;
	shouldEnableDownloadButton: boolean;
}) => {
	const attachmentIdentifiers: FileIdentifier[] = items.map(
		(item: AttachmentActionItem) => item.identifier,
	);

	return items.map((item) => {
		const isInternalAttachment = item.hasRestrictedParent;

		return fg('attachment_grid_view_media_card') ? (
			<MediaCardItem
				item={item}
				attachmentIdentifiers={attachmentIdentifiers}
				mediaClientConfig={mediaClientConfig}
				shouldEnableDownloadButton={shouldEnableDownloadButton}
			/>
		) : (
			<Box xcss={mediaCardStyle} key={item.identifier.id}>
				<Card
					mediaClientConfig={mediaClientConfig}
					mediaViewerItems={attachmentIdentifiers}
					useInlinePlayer={false}
					shouldOpenMediaViewer
					dimensions={cardDimensions}
					featureFlags={mediaFeatureFlags()}
					titleBoxBgColor={
						isInternalAttachment
							? // TODO: https://product-fabric.atlassian.net/browse/DSP-8582
								token('color.background.accent.purple.subtle')
							: undefined
					}
					titleBoxIcon={isInternalAttachment ? 'LockFilledIcon' : undefined}
					shouldEnableDownloadButton={
						!fg('block_attachment_download_on_data_export_dsp_rule') || shouldEnableDownloadButton
					}
					{...item}
					testId={`issue.views.issue-base.content.attachment.grid-view.attachment-id.${item.identifier.attachmentId}`}
				/>
			</Box>
		);
	});
};

const mediaCardStyle = xcss({
	// https://hello.atlassian.net/wiki/spaces/DST/pages/3225764567/Guide+for+Migrating+to+Spacing+Tokens#The-value-I%E2%80%99m-migrating-is-too-large-to-be-represented-with-a-token
	minWidth: '138px',
	width: '100%',
	height: '130px',
	cursor: 'pointer',

	// ':focus': {
	// 	outline: `${token('border.width.outline')} auto ${token('color.border.focused')}`,
	// 	outlineOffset: token('space.025'),
	// },
});

export default MediaCardItems;
